import { useCallback } from 'react';
import { CommonEventOptions } from '@westwing/appshell_types';
import { useGaTracking } from '@ids/appshell';

function useIdsGaTracking() {
    const trackingHelpers = useGaTracking();

    const trackIdsEvent = useCallback(
        (data: CommonEventOptions) => trackingHelpers.trackGenericEvent('Interior Service Tracking', data),
        [trackingHelpers]
    );

    return { ...trackingHelpers, trackIdsEvent };
}

export default useIdsGaTracking;
